import { LabelLangString } from 'component/LabelLang/label-lang'
// import HtmlView from 'component/htmlView/html-view'
import DataNotFound from '../DataNotFound/DataNotFound'
import { useSelector } from 'react-redux'
import { ReactMarkdown } from 'react-markdown/lib/react-markdown'
import rehypeRaw from 'rehype-raw'
import './index.scss'

const AboutDepartment = ({id, txt, translations}) => {

    const currentLocale = useSelector(({ theme }) => theme.locale);

  return (
    <div className="box-d">
        <div className="box-d-header">
            {txt !== null &&
                txt !== undefined ? (
                    <div className="view">
                        <ReactMarkdown
                            children={LabelLangString({
                                id: id,
                                currentLocale: currentLocale,
                                defaultValue: txt,
                                translations: translations,
                                })}
                            rehypePlugins={[rehypeRaw]}
                        />
                    </div>
                // <HtmlView
                //     html={LabelLangString({
                //     id: id,
                //     currentLocale: currentLocale,
                //     defaultValue: txt,
                //     translations: translations,
                //     })}
                // />
                ) : (
                <DataNotFound color='text-white' />
            )}
        </div>
        <div className="box-d-footer">
            <img
                loading="lazy"
                className="up"
                src={process.env.PUBLIC_URL + "/image/pirm.png"}
                alt="prim"
            />
        </div>
    </div>
  )
}

export default AboutDepartment